import './Sustainability.scss';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { RoadmapNavigation } from 'components/steps/RoadmapNavigation/RoadmapNavigation';
import { formatText } from 'core/i18n';
import questionIcon from 'assets/icons/icon_question_mark.png';
import RAModal from 'components/RAComponents/commons/RAModal/RAModal';
import { Option } from './Option';
import { RadioOption } from './RadioOption';
import { isMobile } from 'utilities/browser';
import ArrowUp from 'assets/icons/icon-arrow-up-red.svg';
import ArrowDown from 'assets/icons/icon-arrow-down-red.svg';

export const Sustainability = ({
    immSuitabilityTest,
    RATestWizard,
    raTestActions,
    modalCancelActions,
    raSuitabilityTest,
    userProfile,
    formActions,
}) => {
    const [selectedLevel, setSelectedLevel] = useState('');
    const [selectedId, setSelectedId] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showInfo, setShowInfo] = useState(false);

    const toggleModal = () => setShowModal(prevState => !prevState);

    const getCurrentStepAndSubStep = () => {
        const { currentStep, currentSubStep } = RATestWizard;

        return { currentStep, currentSubStep };
    };

    const getQuestionId = () => {
        const { currentStep, currentSubStep } = getCurrentStepAndSubStep();

        return RATestWizard.steps?.[currentStep].steps?.[currentSubStep].question;
    };

    const getInfo = () => {
        const question = immSuitabilityTest.getIn(['questions', getQuestionId()]);
        const info = question.get('title');

        return info;
    };

    const getAnswers = () => {
        const question = immSuitabilityTest.getIn(['questions', getQuestionId()]);
        const answers = question.get('answers').toJS();

        return answers;
    };

    const handleOptionClick = ({ level, id }) => {
        setSelectedLevel(level);
        setSelectedId(id);
    };

    const handleInfoClick = () => {
        setShowInfo(prevState => !prevState);
    };

    const isFinalizeButtonDisabled = () => {
        return selectedLevel === '';
    };

    const shouldFinalizeButtonBeHidden = selectedId === 'answer2' || selectedId === 'answer3';

    const onHandleContinueButton = () => {
        const { currentStep, currentSubStep } = getCurrentStepAndSubStep();
        raSuitabilityTest.updateAnswerByQuestionId(getQuestionId(), selectedId);

        if (!shouldFinalizeButtonBeHidden) {
            raSuitabilityTest.sendLogs();

            return raSuitabilityTest.sendTest(userProfile.accessToken);
        }

        window.scrollTo(0, 0);
        const data = {
            step: currentStep,
            substep: currentSubStep,
        };
        raTestActions.nextStep(data);
    };

    const onHandleCancelButton = () => {
        modalCancelActions.showModalCancel();
    };

    const onHandlePrevButton = () => {
        raTestActions.prevStep(getCurrentStepAndSubStep());
    };

    const buildAdditionalInfoModal = () => {
        return (
            <>
                <p>{formatText('sustainability-modalSubTitle')}</p>
                <ul>
                    <li>{formatText('sustainability-modalCriteria1')}</li>
                    <li>{formatText('sustainability-modalCriteria2')}</li>
                    <li>{formatText('sustainability-modalCriteria3')}</li>
                </ul>
            </>
        );
    };

    return (
        <main className="ra-sustainability">
            <section className={`ra-sustainability__${isMobile() ? 'title-mobile' : 'title'}`}>
                <h1>
                    {getInfo()}
                    <button onClick={toggleModal} className="ra-sustainability__modal-icon">
                        <img src={questionIcon} alt="sustainabililty hand" />
                    </button>
                </h1>
            </section>

            <RAModal
                title={formatText('sustainability-modalTitle')}
                text={buildAdditionalInfoModal()}
                firstButton={formatText('button-understood')}
                firstAction={toggleModal}
                show={showModal}
                hide={toggleModal}
            />

            <section className="ra-sustainability__info">
                {isMobile() && (
                    <div className="show-info">
                        <button onClick={handleInfoClick}>
                            {formatText(`sustainability-${showInfo ? 'hideInfo' : 'showMoreInfo'}`)}
                            <img src={showInfo ? ArrowUp : ArrowDown} alt="arrow" />
                        </button>
                        {showInfo && <p className="info-expanded">{getInfo()}</p>}
                    </div>
                )}
            </section>

            <section className={`ra-sustainability__${isMobile() ? 'options-mobile' : 'options'}`}>
                {getAnswers().map(({ text, id, level }) => {
                    const answers = [
                        {
                            label: {
                                title: text,
                            },
                            id,
                        },
                    ];

                    return (
                        <>
                            {isMobile() ? (
                                <>
                                    <RadioOption
                                        key={id}
                                        answers={answers}
                                        formActions={formActions}
                                        handleOptionClick={handleOptionClick}
                                        id={id}
                                        level={level}
                                        questionId={getQuestionId()}
                                        userProfile={userProfile}
                                    />
                                </>
                            ) : (
                                <Option
                                    key={id}
                                    handleOptionClick={() => handleOptionClick({ level, id })}
                                    level={level}
                                    text={text}
                                    isSelected={selectedLevel === level}
                                />
                            )}
                        </>
                    );
                })}
            </section>

            <hr />

            <div className="steps-view__footer">
                <RoadmapNavigation
                    buttonContinueType="submit"
                    buttonContinueAction={onHandleContinueButton}
                    buttonContinueText={formatText('suitabilityTest-next')}
                    buttonPrevHidden={false}
                    buttonPrevText={formatText('suitabilityTest-prev')}
                    buttonCancelText={formatText('suitabilityTest-getOut')}
                    buttonPrevAction={onHandlePrevButton}
                    buttonCancelAction={onHandleCancelButton}
                    buttonFinalizeText={formatText('button-finalize')}
                    buttonFinalizeHidden={shouldFinalizeButtonBeHidden}
                    buttonFinalizeDisabled={isFinalizeButtonDisabled()}
                />
            </div>
        </main>
    );
};

Sustainability.propTypes = {
    RATestWizard: PropTypes.object,
    userProfile: PropTypes.object,
    immSuitabilityTest: PropTypes.object,
    raSuitabilityTest: PropTypes.object,
    raTestActions: PropTypes.object,
    stepsActions: PropTypes.object,
    formActions: PropTypes.object,
    modalCancelActions: PropTypes.object,
    questionId: PropTypes.string,
};
